import { useEffect, useState } from "react";
import "./css/VotingGrid.css";
import { supabase } from "../lib/supabase";
import "./css/Modal.css";
import { getDeviceId } from "../getDeviceId";
import checkIfVoted from "../checkVote";

export default function VotingGrid() {
  const [expandedId, setExpandedId] = useState(null);
  const [candidates, setCandidates] = useState([]);
  const [hasVoted, setHasVoted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);

  const confirmVote = async () => {
    const deviceId = getDeviceId();
    const { error } = await supabase.from("votes").insert({
      candidate_id: selectedCandidate.id,
      device_id: deviceId,
      user_agent: navigator.userAgent,
    });

    if (error) {
      if (error.code === "23505") {
        setHasVoted(true);
        alert("⚠️ Ya votaste desde este dispositivo");
      } else {
        alert("Error al votar");
        console.error(error);
      }
    } else {
      setHasVoted(true);
      alert(`💗 Voto confirmado para ${selectedCandidate.name}`);
      setShowModal(false);
    }
    setSelectedCandidate(null);
  };

  const cancelVote = () => {
    setShowModal(false);
    setSelectedCandidate(null);
  };

  useEffect(() => {
    async function init() {
      const voted = await checkIfVoted();
      setHasVoted(voted);
      setLoading(false);
    }
    init();
  }, []);

  function handleVote(candidate) {
    setSelectedCandidate(candidate);
    setShowModal(true);
  }

  useEffect(() => {
    async function loadCandidates() {
      const { data, error } = await supabase
        .from("candidates")
        .select("*")
        .order("created_at", { ascending: true });

      if (error) {
        console.error(error);
      } else {
        setCandidates(data);
      }
    }

    loadCandidates();
  }, []);

  return (
    <>
      <section className="space-container pink-space">
        <div>
          <img className="space-logo" src="./logo.JPG" alt="Logo" />
          <h2 className="space-title">Miss Teen Gay Nicaragua</h2>
          <span className="space-subtitle">
            Lawrence Zeledon © 2026 All rights reserved
          </span>
        </div>

        <div className="space-grid">
          {candidates.map((c) => (
            <article
              key={c.id}
              className={`space-card expandable-card ${
                expandedId === c.id ? "expanded" : ""
              }`}
            >
              <div className="image-wrapper">
                <img className="galaxy-image" src="./galaxy.png" alt="Galaxy" />
                <img className="candidate-image" src={c.photo_url} alt={c.name} />
              </div>

              <div className="card-content glass-content">
                <h3>{c.name}</h3>
                <span className="country">🌍 {c.department}</span>
                <p>{c.description}</p>
                <button
                  className={`vote-button ${
                    loading ? "loading" : hasVoted ? "disabled" : "primary"
                  }`}
                  disabled={loading || hasVoted}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleVote(c);
                  }}
                >
                  {loading
                    ? "Verificando..."
                    : hasVoted
                    ? "Ya votaste ✅"
                    : "💗 Votar"}
                </button>
              </div>
            </article>
          ))}
        </div>
      </section>
      {showModal && (
        <div className="modal-overlay" onClick={cancelVote}>
          <div
            className="modal glass-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>¿Confirmar voto?</h3>

            <p style={{ color: "#fff" }}>
              Estás a punto de votar por
              <strong> {selectedCandidate.name}</strong>
            </p>

            <div className="modal-actions">
              <button className="modal-cancel" onClick={cancelVote}>
                Cancelar
              </button>
              <button className="modal-confirm" onClick={confirmVote}>
                Confirmar 💗
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
